import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';

import Products from './Products';
import Categories from './Categories';

import {
    fetchAllProducts,
    deleteProduct
} from '../../actions/Product';

import {
    fetchAllCategories,
    addCategory,
    updateCategory,
    deleteCategory
} from '../../actions/CategoryActions';

class ProductsIndex extends Component {

    componentDidMount() {

        this.props.fetchAllProducts();
        this.props.fetchAllCategories();
    }

    render() {

        const { 
            location, 
            products, 
            categories,
            isProductLoading, 
            isCategoryLoading, 
            deleteProduct, 
            addCategory, 
            updateCategory, 
            deleteCategory 
        } = this.props;
        let contentView;

        if (location.hash === '#categories') {
            contentView = (<Categories
                categories={categories} 
                isCategoryLoading={isCategoryLoading} 
                addCategory={addCategory} 
                updateCategory={updateCategory} 
                deleteCategory={deleteCategory}
            />
            );
        } else {
            contentView = <Products products={products} categories={categories} isProductLoading={isProductLoading} deleteProduct={deleteProduct} />;
        }

        return (
            <div className="main-content">
                <div className="page-title">Products</div>
                <div className="tab-menu">
                    <Link to={`/products`} className={`item ${location.hash === '' ? 'active' : ''}`}>Products</Link>
                    <Link to={`/products#categories`} className={`item ${location.hash === '#categories' ? 'active' : ''}`}>Categories</Link>
                </div>
                {contentView}
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    const { products, isProductLoading } = state.product;
    const { categories, isCategoryLoading } = state.category;
    return { products, categories, isProductLoading, isCategoryLoading };
}

export default connect(mapStateToProps, {
    fetchAllProducts,
    fetchAllCategories,
    deleteProduct,
    addCategory,
    updateCategory,
    deleteCategory
})(ProductsIndex);



// WEBPACK FOOTER //
// ./src/views/products/index.js